var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgImage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-16px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 2.75C3.01117 2.75 2.75 3.01117 2.75 3.33333V12.6667C2.75 12.8982 2.88485 13.0982 3.08027 13.1924L10.1363 6.13634C10.4292 5.84344 10.9041 5.84344 11.197 6.13634L13.25 8.18934V3.33333C13.25 3.01117 12.9888 2.75 12.6667 2.75H3.33333ZM13.25 10.3107L10.6667 7.72733L5.14399 13.25H12.6667C12.9888 13.25 13.25 12.9888 13.25 12.6667V10.3107ZM1.25 3.33333C1.25 2.18274 2.18274 1.25 3.33333 1.25H12.6667C13.8173 1.25 14.75 2.18274 14.75 3.33333V12.6667C14.75 13.8173 13.8173 14.75 12.6667 14.75H3.33333C2.18274 14.75 1.25 13.8173 1.25 12.6667V3.33333ZM5.66667 5.41667C5.5286 5.41667 5.41667 5.5286 5.41667 5.66667C5.41667 5.80474 5.5286 5.91667 5.66667 5.91667C5.80474 5.91667 5.91667 5.80474 5.91667 5.66667C5.91667 5.5286 5.80474 5.41667 5.66667 5.41667ZM3.91667 5.66667C3.91667 4.70017 4.70017 3.91667 5.66667 3.91667C6.63317 3.91667 7.41667 4.70017 7.41667 5.66667C7.41667 6.63317 6.63317 7.41667 5.66667 7.41667C4.70017 7.41667 3.91667 6.63317 3.91667 5.66667Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/image.82fd035d.svg";
export { ForwardRef as ReactComponent };